import React, { useState,useEffect } from "react";
import {Select} from "@appkit4/react-components/select"
import {Input} from "@appkit4/react-components/field"
import "../vendormanagement.css";
import { ErrorMessage, FieldArray } from "formik";
import PropTypes from 'prop-types';
import APIService from "../../../../services/apiAxiosService";
import useHttp from "../../../../hooks/useHttp"
function Questionnaire(props) {
  const { sendRequest: getScoreData } = useHttp();

  const[val,setVal]=useState(0);
  const[score,setScore]=useState([]);
  let { values, handleChange, handleBlur,role,allInherentRisk } = props;
  let disabledFields;
  if (role === "analyst" || role === "manager") {
    disabledFields = true
  }
  else {
    disabledFields = false //Can be changed according to future requirement.
  }


  

  useEffect(() => {
    getScoreData(APIService.getScoreData(), responseHandlerScore, errorHandler)
   
  },[])

  const getScore=(risk,ques)=>{
    
const scoreData=score?.filter((val)=> val.ques==ques && val.riskid == risk)

return scoreData[0]?.scorepoint;
  }

  

  const responseHandlerScore = (result) => {
    if (result.CODE) {
      setScore(result.MSG);
    }
  }

  
  const errorHandler = () => {
    displayToastMessage("Something went wrong, Please try again!", "error");
  }

 
  const getTextFields = (...params) => {
    if (params[0] === "select") {
      return (
        <div className={disabledFields ? "questionnaire-select-disabled input-field-border" : "questionnaire-select input-field-border"}>
          <Select
            showSearchOnToggle={true}
            dropdownRenderMode="portal"
            searchable={true}
            className="cv-input-field"
            data={params[2]}
            labelKey="Name"
            valueKey="optionID"
            value={Number(values.questions[params[3]].response)}
            onSelect={(e) =>
              handleChange(`questions[${params[3]}].response`)({
                target: { value: e },
              },               
            )
            }
            placeholder="Select"
            disabled={disabledFields}
            
          >
          </Select>
        </div>
      );
    } else if (params[0] === "int" || params[0] === "text") {
      return (
        <Input
          type="text"
          className={disabledFields ? "cv-input-field-disabled input-field-border": "cv-input-field input-field-border"}
          value={values.questions[params[3]].response}
          onChange={handleChange(`questions[${params[3]}].response`)}
          title="Fill response"
          disabled={disabledFields}
        />
      );
    }
    
  };

  return (
    <div className="questions-h">
      <FieldArray
        name="questions"
        render={(arrayHelpers) =>
          values.questions.map((item, index) => {
            return (
              <div className="row p-3" key={index}>
                <div className="col-sm-10">
                  {item.question}
                  <span className="asterisk-required">*</span>
                </div>
                <div className="col-sm-2">
                  {getTextFields(
                    item.questionType,
                    item.response,
                    item.dropDownValues,
                    index
                  )}
                  <span style={{ color: "#ff0000" }}>
                    <ErrorMessage name={`questions[${index}].response`} />
                  </span>
                </div>
                {role === "analyst" &&
                <>
                <div className="col-sm-2  input-field-border">
                  
                <Select
            showSearchOnToggle={true}
            dropdownRenderMode="portal"
            searchable={true}
            className="cv-input-field"
            onBlur={handleBlur}
            data={allInherentRisk}
            labelKey="risk_name"
            valueKey="risk_id"
              value={Number(values.questions[index].risk)}
            onSelect={(e) =>
              handleChange(`questions[${index}].risk`)({
                target: { value: e }
              },             
            )

            }
            placeholder="Select"
             name="risk"
          >
          </Select>
         
               
                </div>
                 <div className="col-sm-2 input-field-border ">
                  
                 <Input
                          type="text"
                          className={"cv-input-field"}
                             value={getScore(Number(values.questions[index].risk),Number(values.questions[index].questionID)) }
                          onBlur={handleBlur}
                          title="Fill response"
                           disabled={disabledFields}
                        />
                                  </div>
                                  </>
          }
              </div>
              
            );
          })
        }
      />
      
    </div>
    
  );
}
Questionnaire.propTypes = {
  values: PropTypes.object,
  role:PropTypes.string,
  handleChange:PropTypes.func,
  handleBlur:PropTypes.func,
}
export default Questionnaire;
